class DataImportOldRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = "DataImportOld";

        super(entityName);

        this.tabName = "DataImportOld";

        App.Objects = App.Objects || {};
        App.Objects[this.tabName] = this;
        Monet.Session[this.tabName] = {};
        Monet.Session[this.tabName].urlCSVProgress =
            Monet.Session[this.tabName].urlCSVProgress || "Import/CSV/Job/";
    }

    show = msg => {
        this.getUserProcess(msg);
        this.checkIfUpdaterIsRuning();
    };

    getUserProcess = () => {
        var request = new Monet.Ajax();
        request.url = Monet.Session[this.tabName].urlCSVProgress;
        request.success = data => this.makeStatusList(data, this);
        request.send();
    };

    DataImportIndexTemplate = data => {
        return new Monet.UI.LayoutGenerator({
            items: [
                {
                    tag: "form",
                    items: [
                        {
                            items: [
                                {
                                    items: [
                                        {
                                            tag: "input",
                                            attributes: {
                                                type: "button",
                                                value: data.btnValue,
                                                name: "btnImport",
                                                id: "btnImport",
                                                class: "btn i18nResource"
                                            }
                                        }
                                    ],
                                    attributes: {
                                        style: "position:relative; float:left; width: 100%"
                                    }
                                }
                            ],
                            attributes: {
                                class: "row"
                            }
                        },
                        {
                            items: [
                                {
                                    items: [
                                        {
                                            tag: "h1",
                                            items: [
                                                {
                                                    tag: "span",
                                                    html: data.groupName,
                                                    attributes: {
                                                        class: "i18nResource"
                                                    }
                                                }
                                            ]
                                        }
                                    ],
                                    attributes: {
                                        class: "form_section_header"
                                    }
                                }
                            ],
                            attributes: {
                                class: "row"
                            }
                        },
                        {
                            items: [],
                            attributes: {
                                id: "dataImporterScrollContainer"
                            }
                        }
                    ],
                    attributes: {
                        id: "form_DataImport"
                    }
                }
            ]
        }).render();
    };

    makeStatusList = (data, scope) => {
        var activeList = document.createDocumentFragment();
        var dataImportTabContainer = document.getElementById(this.tabName);
        var help = new Monet.UI.Help(
            "DataImport",
            Monet.I18n.getResourcesByKey("Greenmile.DataImport.screenName")
        );

        dataImportTabContainer.innerHTML = "";
        dataImportTabContainer.appendChild(
            this.DataImportIndexTemplate({
                groupName: Monet.I18n.getResourcesByKey("FileImport.Group.Title"),
                btnValue: Monet.I18n.getResourcesByKey("FileImport.BtnImport.Value")
            })
        );
        dataImportTabContainer.appendChild(help.render());

        var dataImporterScrollContainer = document.getElementById("dataImporterScrollContainer");
        var importBtn = document.getElementById("btnImport");
        var noDataImportingDiv = document.createElement("div");
        var noDataImportingLabel = document.createElement("div");

        noDataImportingDiv.className = "DataImportNoDataImportingImage";
        noDataImportingLabel.className = "DataImportNoDataImportingText";
        noDataImportingLabel.innerHTML = Monet.I18n.getResourcesByKey(
            "DataImport.nothingImporting"
        );

        importBtn.addEventListener(
            "click",
            (function (scope) {
                return function () {
                    scope.newForm(scope);
                };
            })(scope)
        );

        if (data) {
            var dataLength = data.length;

            if (dataLength) {
                for (var i = 0; i < dataLength; i++) {
                    activeList.appendChild(scope.makeStatusItem(data[i]));
                }

                dataImporterScrollContainer.appendChild(activeList);
            } else {
                dataImporterScrollContainer.appendChild(noDataImportingDiv);
                dataImporterScrollContainer.appendChild(noDataImportingLabel);
            }
        }
    };

    setStatusClassToProgress = (data, progress) => {
        switch (data.status) {
            case "STARTED":
            case "PROCESSING":
            case "SUCCESS":
                progress.className =
                    "dataImporterStatusProgress dataImporterStatusSuccess";
                break;
            case "PENDING":
                progress.className =
                    "dataImporterStatusProgress dataImporterStatusPending";
                break;
            case "FAILURE":
                progress.className =
                    "dataImporterStatusProgress dataImporterStatusFailure";
                break;
            default:
                console.log(
                    "In setStatusClassToProgress not have an default status, file: DataImport"
                );
                break;
        }
    };

    makeStatusItem = data => {
        var importInfoContainer = document.createElement("div"),
            whenLabel = document.createElement("label"),
            progressLabel = document.createElement("label"),
            statusLabel = document.createElement("label"),
            progress = document.createElement("div"),
            status = document.createElement("div"),
            fileDiv = document.createElement("div"),
            whenDiv = document.createElement("div");

        fileDiv.style.width = "100%";
        fileDiv.style.marginLeft = "0";
        fileDiv.style.fontSize = "16px";

        importInfoContainer.className = "dataImporterContainer";

        statusLabel.innerHTML = Monet.I18n.getResourcesByKey(
            "FileImport.Status.Label"
        );
        progressLabel.innerHTML = Monet.I18n.getResourcesByKey(
            "FileImport.Progress.Label"
        );
        whenLabel.innerHTML = Monet.I18n.getResourcesByKey("FileImport.When.Label");

        this.setStatusClassToProgress(data, progress);

        var res = Monet.I18n.getResourcesByKey(data.resourceId);

        fileDiv.innerHTML = res.replace("[%s]", ": " + data.jobName);

        progress.style.backgroundSize = data.progress + "% 50px";
        progress.innerHTML = data.progress + "% ";

        status.innerHTML = Monet.I18n.getResourcesByKey(
            "DataImport.JobsLists." + data.status
        );

        if (data.when) {
            whenDiv.innerHTML = Monet.Format.DateTime.formatToLocale(data.when);
        }

        importInfoContainer.appendChild(fileDiv);
        importInfoContainer.appendChild(progressLabel);
        importInfoContainer.appendChild(progress);
        importInfoContainer.appendChild(statusLabel);
        importInfoContainer.appendChild(status);
        importInfoContainer.appendChild(whenLabel);
        importInfoContainer.appendChild(whenDiv);

        importInfoContainer.addEventListener(
            "click",
            (function (scope, data) {
                return function () {
                    scope.getImportStatus(data.key);
                };
            })(this, data)
        );

        var checkImportStatus = (function (scope) {
            return function (data, obj) {
                scope.getImportStatus(data.key, obj);
            };
        })(this);

        var timerUpdateProgress = setInterval(function () {
            var obj = {
                status: status,
                field: progress,
                checkStatus: "checkStatus",
                classProgress: "dataImporterStatusProgress dataImporterStatus",
                timer: timerUpdateProgress
            };
            if (data.status !== "SUCCESS" && data.status !== "FAILURE") {
                checkImportStatus(data, obj);
            } else {
                clearInterval(timerUpdateProgress);
            }
        }, 6000);

        return importInfoContainer;
    };

    checkIfUpdaterIsRuning = () => {
        if (!Monet.Session[this.tabName].updater) {
            Monet.Session[this.tabName].updater = setInterval(
                (function (scope) {
                    return function () {
                        var currentTab = Monet.Utils.GetTabName();

                        if (currentTab === this.tabName) {
                            scope.getUserProcess();

                            console.log("Data importer updated at " + new Date());
                        } else {
                            clearInterval(Monet.Session[this.tabName].updater);
                            delete Monet.Session[this.tabName].updater;
                        }
                    };
                })(this),
                1000000000
            );
        }
    };

    DataImportFormTemplate = data => {
        return new Monet.UI.LayoutGenerator({
            items: [
                {
                    items: [
                        {
                            tag: "form",
                            items: [
                                {
                                    items: [
                                        {
                                            attributes: {
                                                class: "monet-message alert alert-error",
                                                style: "display: none;"
                                            }
                                        }
                                    ],
                                    attributes: {
                                        class: "monetInlineAlerContainer"
                                    }
                                },
                                {
                                    items: [
                                        {
                                            items: [
                                                {
                                                    tag: "input",
                                                    attributes: {
                                                        type: "submit",
                                                        value: data.btnUpload,
                                                        name: "btnUploadFile",
                                                        id: "btnUploadFile",
                                                        class: "btn",
                                                        form: "form_AccountPerformanceReportForm"
                                                    }
                                                },
                                                {
                                                    tag: "input",
                                                    attributes: {
                                                        type: "button",
                                                        value: data.btnCancel,
                                                        name: "btnCancelUpload",
                                                        id: "btnCancelUpload",
                                                        class: "btn btn-secondary"
                                                    }
                                                }
                                            ],
                                            attributes: {
                                                style: "position:relative; float:left; width: 100%"
                                            }
                                        },
                                        {
                                            items: [
                                                {
                                                    tag: "input",
                                                    attributes: {
                                                        type: "hidden",
                                                        id: "identity_id",
                                                        value: "",
                                                        class: "modelAttribute"
                                                    }
                                                },
                                                {
                                                    tag: "input",
                                                    attributes: {
                                                        type: "hidden",
                                                        id: "entity_name",
                                                        value: "Equipment",
                                                        class: "modelAttribute"
                                                    }
                                                }
                                            ],
                                            attributes: {
                                                class: "span8"
                                            }
                                        }
                                    ],
                                    attributes: {
                                        class: "row"
                                    }
                                },
                                {
                                    items: [
                                        {
                                            items: [
                                                {
                                                    tag: "h1",
                                                    items: [
                                                        {
                                                            tag: "span",
                                                            attributes: {
                                                                class: "i18nResource"
                                                            }
                                                        }
                                                    ]
                                                }
                                            ],
                                            attributes: {
                                                class: "form_section_header"
                                            }
                                        },
                                        {
                                            items: [
                                                {
                                                    items: [
                                                        {
                                                            items: [
                                                                {
                                                                    tag: "label",
                                                                    items: [
                                                                        {
                                                                            tag: "span",
                                                                            html: data.organizationLabel,
                                                                            attributes: {
                                                                                class: "i18nResource"
                                                                            }
                                                                        }
                                                                    ],
                                                                    attributes: {
                                                                        for: "organization_description"
                                                                    }
                                                                },
                                                                {
                                                                    items: [
                                                                        {
                                                                            tag: "input",
                                                                            attributes: {
                                                                                type: "text",
                                                                                name: "organization_description",
                                                                                alt: "",
                                                                                lookup_entity: "Organization",
                                                                                value: "",
                                                                                rel: "description",
                                                                                id: "organization_description",
                                                                                class:
                                                                                    "searchField ui-autocomplete-input ui-corner-top",
                                                                                autocomplete: "off"
                                                                            }
                                                                        },
                                                                        {
                                                                            tag: "input",
                                                                            attributes: {
                                                                                type: "hidden",
                                                                                id: "organization_id",
                                                                                class: "modelAttribute",
                                                                                name: "organization.id",
                                                                                value: ""
                                                                            }
                                                                        },
                                                                        {
                                                                            attributes: {
                                                                                class: "searchClickzone"
                                                                            }
                                                                        }
                                                                    ],
                                                                    attributes: {
                                                                        class: "controls"
                                                                    }
                                                                }
                                                            ],
                                                            attributes: {
                                                                class: "control-group"
                                                            }
                                                        },
                                                        {
                                                            items: [
                                                                {
                                                                    tag: "label",
                                                                    items: [
                                                                        {
                                                                            tag: "span",
                                                                            html: data.fileLabel,
                                                                            attributes: {
                                                                                class: "i18nResource"
                                                                            }
                                                                        }
                                                                    ],
                                                                    attributes: {
                                                                        for: "organization_description"
                                                                    }
                                                                },
                                                                {
                                                                    items: [
                                                                        {
                                                                            tag: "input",
                                                                            attributes: {
                                                                                type: "file",
                                                                                name: "file"
                                                                            }
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            attributes: {
                                                                class: "control-group"
                                                            }
                                                        }
                                                    ],
                                                    attributes: {
                                                        class: "form-horizontal"
                                                    }
                                                },
                                                {
                                                    items: [
                                                        {
                                                            tag: "label",
                                                            items: [
                                                                {
                                                                    tag: "span",
                                                                    html: data.dataType,
                                                                    attributes: {
                                                                        class: "i18nResource"
                                                                    }
                                                                }
                                                            ],
                                                            attributes: {
                                                                class: "control-label"
                                                            }
                                                        },
                                                        {
                                                            items: [
                                                                {
                                                                    items: [
                                                                        {
                                                                            tag: "input",
                                                                            attributes: {
                                                                                type: "radio",
                                                                                name: "reportType",
                                                                                value: "Location",
                                                                                id: "DataImporterLocationRadio",
                                                                                checked: ""
                                                                            }
                                                                        },
                                                                        {
                                                                            tag: "label",
                                                                            html: data.dataTypeLocation,
                                                                            attributes: {
                                                                                class: "radio_label",
                                                                                for: "DataImporterLocationRadio"
                                                                            }
                                                                        }
                                                                    ],
                                                                    attributes: {
                                                                        class: "radio_group_item"
                                                                    }
                                                                },
                                                                {
                                                                    items: [
                                                                        {
                                                                            tag: "input",
                                                                            attributes: {
                                                                                type: "radio",
                                                                                name: "reportType",
                                                                                value: "Driver",
                                                                                id: "DataImporterDriverRadio"
                                                                            }
                                                                        },
                                                                        {
                                                                            tag: "label",
                                                                            html: data.dataTypeDriver,
                                                                            attributes: {
                                                                                class: "radio_label",
                                                                                for: "DataImporterDriverRadio"
                                                                            }
                                                                        }
                                                                    ],
                                                                    attributes: {
                                                                        class: "radio_group_item"
                                                                    }
                                                                },
                                                                {
                                                                    items: [
                                                                        {
                                                                            tag: "input",
                                                                            attributes: {
                                                                                type: "radio",
                                                                                name: "reportType",
                                                                                value: "Equipment",
                                                                                id: "DataImporterEquipmentRadio"
                                                                            }
                                                                        },
                                                                        {
                                                                            tag: "label",
                                                                            html: data.dataTypeEquipment,
                                                                            attributes: {
                                                                                class: "radio_label",
                                                                                for: "DataImporterEquipmentRadio"
                                                                            }
                                                                        }
                                                                    ],
                                                                    attributes: {
                                                                        class: "radio_group_item"
                                                                    }
                                                                },
                                                                {
                                                                    items: [
                                                                        {
                                                                            tag: "input",
                                                                            attributes: {
                                                                                type: "radio",
                                                                                name: "reportType",
                                                                                value: "Route",
                                                                                id: "DataImporterRouteRadio"
                                                                            }
                                                                        },
                                                                        {
                                                                            tag: "label",
                                                                            html: data.dataTypeRoute,
                                                                            attributes: {
                                                                                class: "radio_label",
                                                                                for: "DataImporterRouteRadio"
                                                                            }
                                                                        }
                                                                    ],
                                                                    attributes: {
                                                                        class: "radio_group_item"
                                                                    }
                                                                },
                                                                {
                                                                    items: [
                                                                        {
                                                                            tag: "input",
                                                                            attributes: {
                                                                                type: "radio",
                                                                                name: "reportType",
                                                                                value: "DriverLocation",
                                                                                id: "DataImporterDriverLocationRadio"
                                                                            }
                                                                        },
                                                                        {
                                                                            tag: "label",
                                                                            html: data.dataTypeDriverLocation,
                                                                            attributes: {
                                                                                class: "radio_label",
                                                                                for: "DataImporterDriverLocationRadio"
                                                                            }
                                                                        }
                                                                    ],
                                                                    attributes: {
                                                                        class: "radio_group_item"
                                                                    }
                                                                },
                                                                {
                                                                    items: [
                                                                        {
                                                                            tag: "input",
                                                                            attributes: {
                                                                                type: "radio",
                                                                                name: "reportType",
                                                                                value: "Paragon",
                                                                                id: "DataImporterParagonRadio"
                                                                            }
                                                                        },
                                                                        {
                                                                            tag: "label",
                                                                            html: data.dataTypeParagon,
                                                                            attributes: {
                                                                                class: "radio_label",
                                                                                for: "DataImporterParagonRadio"
                                                                            }
                                                                        }
                                                                    ],
                                                                    attributes: {
                                                                        class: "radio_group_item"
                                                                    }
                                                                },
                                                                {
                                                                    items: [
                                                                        {
                                                                            tag: "input",
                                                                            attributes: {
                                                                                type: "radio",
                                                                                name: "reportType",
                                                                                value: "SpecialUserLocation",
                                                                                id:
                                                                                    "DataImporterSpecialUserLocationRadio"
                                                                            }
                                                                        },
                                                                        {
                                                                            tag: "label",
                                                                            html: data.dataTypeSpecialUserLocation,
                                                                            attributes: {
                                                                                class: "radio_label",
                                                                                for: "DataImporterSpecialUserLocationRadio"
                                                                            }
                                                                        }
                                                                    ],
                                                                    attributes: {
                                                                        class: "radio_group_item"
                                                                    }
                                                                }
                                                            ],
                                                            attributes: {
                                                                id: "dataImporterType",
                                                                class: "controls"
                                                            }
                                                        }
                                                    ],
                                                    attributes: {
                                                        class: "control-group"
                                                    }
                                                }
                                            ],
                                            attributes: {
                                                class: "span4"
                                            }
                                        }
                                    ],
                                    attributes: {
                                        class: "row"
                                    }
                                }
                            ],
                            attributes: {
                                id: "form_AccountPerformanceReportForm",
                                enctype: "multipart/form-data",
                                method: "post"
                            }
                        }
                    ],
                    attributes: {
                        class: "span10 form_and_grid_generic"
                    }
                }
            ]
        }).render();
    };

    newForm = scope => {
        clearInterval(Monet.Session[this.tabName].updater);
        delete Monet.Session[this.tabName].updater;

        var dataImportContainer = document.getElementById(this.tabName);
        var help = new Monet.UI.Help(
            "DataImportForm",
            Monet.I18n.getResourcesByKey("Greenmile.DataImport.screenName")
        );

        dataImportContainer.innerHTML = "";
        dataImportContainer.appendChild(
            this.DataImportFormTemplate({
                btnUpload: Monet.I18n.getResourcesByKey(
                    "DataImport.UploadForm.btnUpload"
                ),
                btnCancel: Monet.I18n.getResourcesByKey("DataImport.UploadForm.cancel"),
                dataType: Monet.I18n.getResourcesByKey(
                    "DataImport.UploadForm.dataType"
                ),
                dataTypeParagon: Monet.I18n.getResourcesByKey(
                    "DataImport.UploadForm.csvParagon"
                ),
                dataTypeLocation: Monet.I18n.getResourcesByKey(
                    "DataImport.UploadForm.LocationLabel"
                ),
                dataTypeDriver: Monet.I18n.getResourcesByKey(
                    "DataImport.UploadForm.DriverLabel"
                ),
                dataTypeEquipment: Monet.I18n.getResourcesByKey(
                    "DataImport.UploadForm.EquipmentLabel"
                ),
                dataTypeRoute: Monet.I18n.getResourcesByKey(
                    "DataImport.UploadForm.RouteLabel"
                ),
                dataTypeDriverLocation: Monet.I18n.getResourcesByKey(
                    "DataImport.UploadForm.DriverLocationLabel"
                ),
                dataTypeSpecialUserLocation: Monet.I18n.getResourcesByKey(
                    "DataImport.UploadForm.SpecialUserLocationLabel"
                ),
                fileLabel: Monet.I18n.getResourcesByKey(
                    "DataImport.UploadForm.FileLabel"
                ),
                organizationLabel: Monet.I18n.getResourcesByKey(
                    "DataImport.UploadForm.OrganizationLabel"
                )
            })
        );

        dataImportContainer.appendChild(help.render());

        var btnCancel = document.getElementById("btnCancelUpload");
        var form = document.getElementById("form_AccountPerformanceReportForm");

        btnCancel.addEventListener(
            "click",
            (function (scope) {
                return function () {
                    scope.getUserProcess();
                };
            })(scope)
        );

        form.addEventListener("submit", this.validateForm.bind(this));

        var lookUpContainer = document.querySelector(
            '#form_AccountPerformanceReportForm > div:nth-child(3) > div.span4 > div.form-horizontal > div:nth-child(1)'
        );
        lookUpContainer.innerHTML = "";

        var lookup = new Monet.UI.Fields.PowerLookup();
        var tabName = this.tabName;
        var nameField = "organization";
        var nameFieldFormatted = "Organization";
        var nameSpace = tabName + "Lookup" + nameFieldFormatted;

        lookup.setId("organization_description");
        lookup.setNameSpace(nameSpace);
        lookup.setBaseSelector("#organization_description");
        lookup.setDisplayKey("description");
        lookup.setLookUpEntity("Organization");
        lookup.render();
        lookup.setInputName(nameField);
        lookup.setTextLabel(
            Monet.I18n.getResourcesByKey("DataImport.UploadForm.OrganizationLabel")
        );

        lookUpContainer.appendChild(lookup.rootEl);

        lookup.postRender();
    };

    uploadFile = (file, url) => {

        const triggerLoaderInBtn = () => {
            const dataImportOldLookupOrganization = App.Forms.DataImportOldLookupOrganization.lookupElement;
            const inputs = dataImportOldLookupOrganization.input.form;
            inputs[0].disabled = !inputs[0].disabled;
            inputs[0].classList && inputs[0].classList.toggle("loader-spinner");
            inputs[1].disabled = !inputs[1].disabled;
        };


        const convertFileToBinary = (fileBase64) => {
            if (!fileBase64) {
                return new Uint8Array(new ArrayBuffer(0));
            }
            const BASE64_MARKER = ';base64,';
            const base64Index = fileBase64.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
            const base64 = fileBase64.substring(base64Index);
            const raw = atob(base64);
            const rawLength = raw.length;
            const array = new Uint8Array(new ArrayBuffer(rawLength));
            for (let i = 0; i < rawLength; i++) {
                array[i] = raw.charCodeAt(i);
            }
            return array;
        };

        triggerLoaderInBtn();
        //Create form data with file as a blob
        const formData = new FormData();
        formData.append('file', new Blob([convertFileToBinary(file)]));

        const ajax = new Monet.Ajax({ contentType: 'multipart/form-data' });
        ajax.url = url;
        ajax.method = 'post';
        ajax.isFile = true;
        ajax.data = formData;
        ajax.success = () => {
            this.getUserProcess();
        };
        ajax.error = () => {
            triggerLoaderInBtn();
            this.renderErrors([Monet.I18n.getResourcesByKey('auth.genericError')]);
        };
        ajax.send();
    };

    renderErrors = (errorList) => {
        const tabId = '#' + this.tabName;
        const erroContainer = document.querySelector(tabId + ' .alert.alert-error');

        let errorContent = '';
        errorList.forEach(error => {
            errorContent += `<li>${error}</li>`;
        });

        erroContainer.style.display = 'block';
        erroContainer.innerHTML = errorContent;
    };

    validateForm = (e) => {

        var tabId = '#' + this.tabName,
            organization = document.querySelector(tabId + ' #organization_id'),
            checkedRadio = document.querySelector(tabId + ' input[type="radio"]:checked'),
            fileField = document.querySelector(tabId + ' input[type="file"]'),
            errorList = [];

        e.preventDefault();

        if (!organization.value) {
            errorList.push(Monet.I18n.getResourcesByKey('DataImport.Error.cantUploadWithoutOrganization'));
        }

        if (!fileField.value) {
            errorList.push(Monet.I18n.getResourcesByKey('DataImport.Error.cantUploadWithoutFile'));
        }

        if (errorList.length) {
            this.renderErrors(errorList);
            App.Forms.DataImportOldLookupOrganization.lookupElement.postRender();
        } else {
            const file = fileField.files[0];
            const url = 'Import/CSV/' + checkedRadio.value + '/' + organization.value;
            const reader = new FileReader();
            reader.onload = () => {
                this.uploadFile(reader.result, url); //pass file as base64
            };
            if (file) {
                reader.readAsDataURL(file);
            }
        }
    };

    writeLogToModal = data => {
        var tabId = "#" + this.tabName;
        var modalContainer = document.querySelector(tabId + " .popupFormContainer");
        var logListContainer = document.createElement("div");
        var fragment = document.createDocumentFragment();
        var messages = null;

        logListContainer.className = "DataImportLogListContainer";

        if (data.erroMessages) {
            messages = data.erroMessages;

            for (var i = 0, l = messages.length; i < l; i++) {
                var item = document.createElement("div");
                item.innerHTML = messages[i].message;

                fragment.appendChild(item);
            }

            logListContainer.appendChild(fragment);
            modalContainer.appendChild(logListContainer);
        }
    };

    getImportStatus = (token, obj) => {
        var request = new Monet.Ajax();
        var objProgress = obj ? obj : null;
        request.url = Monet.Session[this.tabName].urlCSVProgress + token;
        request.success = (function (scope) {
            return function (data) {
                scope.showImportStatus(data, objProgress);
            };
        })(this);

        request.send();
    };

    showImportStatus = (data, objProgress) => {
        if (objProgress === null) {
            if (data.status === "FAILURE") {
                var selector = "#" + this.tabName;
                var scopeBlock = selector;
                var options = { width: 900, height: 530 };
                var callbacks = {
                    onAfterShowModalForm: (function (data, scope) {
                        return function () {
                            scope.writeLogToModal(data);
                        };
                    })(data, this)
                };

                this.modalForm = new Monet.Form.Modal(
                    selector,
                    options,
                    callbacks,
                    scopeBlock
                );

                this.modalForm.showModalForm();
            }

            clearInterval(Monet.Session[this.tabName].updater);
            delete Monet.Session[this.tabName].updater;
        } else {
            objProgress.field.style.backgroundSize = data.progress + "% 50px";
            objProgress.field.innerHTML = data.progress + "% ";

            if (data.progress === 100) {
                objProgress.status.innerHTML = Monet.I18n.getResourcesByKey(
                    "DataImport.JobsLists." + data.status
                );

                this.setStatusClassToProgress(data, objProgress.field);

                clearInterval(objProgress.timer);
            }
        }
    };
}

App.Routers.DataImportOld = DataImportOldRouter;
